var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 12.5V15.8333C13.3334 17.2167 12.2167 18.3333 10.8334 18.3333H9.16675C7.78341 18.3333 6.66675 17.2167 6.66675 15.8333V12.5H13.3334Z",
    fill: "#838B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 5.83317V4.1665C5.83325 2.78317 6.94992 1.6665 8.33325 1.6665H11.6666C13.0499 1.6665 14.1666 2.78317 14.1666 4.1665V5.83317H5.83325Z",
    fill: "#838B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.8335H5C3.33333 5.8335 2.5 6.66683 2.5 8.3335V12.5002C2.5 14.1668 3.33333 15.0002 5 15.0002H6.66667V12.5002H13.3333V15.0002H15C16.6667 15.0002 17.5 14.1668 17.5 12.5002V8.3335C17.5 6.66683 16.6667 5.8335 15 5.8335ZM8.33333 9.79183H5.83333C5.49167 9.79183 5.20833 9.5085 5.20833 9.16683C5.20833 8.82516 5.49167 8.54183 5.83333 8.54183H8.33333C8.675 8.54183 8.95833 8.82516 8.95833 9.16683C8.95833 9.5085 8.675 9.79183 8.33333 9.79183Z",
    fill: "#CCCFD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95825 9.1665C8.95825 9.50817 8.67492 9.7915 8.33325 9.7915H5.83325C5.49159 9.7915 5.20825 9.50817 5.20825 9.1665C5.20825 8.82484 5.49159 8.5415 5.83325 8.5415H8.33325C8.67492 8.5415 8.95825 8.82484 8.95825 9.1665Z",
    fill: "#838B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 13.125H5.83325C5.49159 13.125 5.20825 12.8417 5.20825 12.5C5.20825 12.1583 5.49159 11.875 5.83325 11.875H14.1666C14.5083 11.875 14.7916 12.1583 14.7916 12.5C14.7916 12.8417 14.5083 13.125 14.1666 13.125Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.11c6a58fb284421dab74e01bf6ce3ac4.svg";
export { ForwardRef as ReactComponent };